import { render, staticRenderFns } from "./afterSaleDrawer.vue?vue&type=template&id=59aa2308&scoped=true&"
import script from "./afterSaleDrawer.vue?vue&type=script&lang=js&"
export * from "./afterSaleDrawer.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleDrawer.vue?vue&type=style&index=0&id=59aa2308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aa2308",
  null
  
)

export default component.exports